module.exports = __webpack_public_path__ + "static/media/countdata.cb23d565.png";